export default __webpack_public_path__ + "static/media/logo.13603f10.svg";